import PropTypes from "prop-types";
import { Pen } from "lucide-react";
import { useNavigate } from "react-router";
import ActionIconButton from "components/ActionIconButton";

/**
 * Admin edit shortcut.
 * Modules open inside the parent formation wizard:
 *   /admin/edit-formation/:formationId?module=:moduleId
 */
const EditButton = ({ id, type, size = "medium", parentId = null, to = null }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e && e.stopPropagation();
    if (to) {
      navigate(to);
      return;
    }
    if (type === "module") {
      if (parentId) {
        navigate(`/admin/edit-formation/${parentId}?module=${id}`);
        return;
      }
      navigate(`/admin/edit-module/${id}`);
      return;
    }
    navigate(`/admin/edit-${type}/${id}`);
  };

  return (
    <ActionIconButton
      title="Modifier"
      onClick={handleClick}
      size={size}
      sx={{ zIndex: 999 }}
    >
      {(iconSize) => (
        <Pen color="currentColor" size={iconSize} strokeWidth={2} />
      )}
    </ActionIconButton>
  );
};

EditButton.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  to: PropTypes.string,
};

export default EditButton;
